export default {"src":"/_next/static/media/our-usp.2527bf23.svg","height":280,"width":590};